import { useTranslation } from 'react-i18next';
import SectionHead from '../shared/SectionHead';
import { useReveal } from '../../hooks/useReveal';

const COUNTS = ['30+', '21+', '3+', '10+'];

export default function ClientGrid() {
  const { t } = useTranslation();
  const ref = useReveal({ stagger: 0.08 });
  const rows = t('home.client_grid.rows', { returnObjects: true });

  return (
    <section
      ref={ref}
      id="clientes"
      className="section"
      style={{ background: 'var(--p2a-dark-bg)', borderBottom: '1px solid var(--p2a-dark-border)' }}
    >
      <div className="p2-container">
        <SectionHead
          eyebrow={t('home.client_grid.eyebrow')}
          title={t('home.client_grid.title')}
          lede={t('home.client_grid.lede')}
          max={560}
        />
        <div
          className="clients-grid"
          style={{
            display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)',
            marginTop: 56,
            borderTop: '1px solid var(--p2a-dark-border)',
            borderLeft: '1px solid var(--p2a-dark-border)',
          }}
        >
          {rows.map((r, i) => (
            <div
              key={i}
              className="reveal"
              style={{
                padding: '28px 24px',
                borderRight: '1px solid var(--p2a-dark-border)',
                borderBottom: '1px solid var(--p2a-dark-border)',
                display: 'flex', flexDirection: 'column',
                minHeight: 140,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
                <span className="mono" style={{ fontSize: 36, fontWeight: 600, letterSpacing: '-0.02em', color: 'var(--p2a-dark-fg-1)' }}>
                  {COUNTS[i]}
                </span>
                <span className="mono" style={{ fontSize: 11, letterSpacing: '0.14em', color: 'var(--p2a-green-400)' }}>
                  {t('home.client_grid.active_tag')}
                </span>
              </div>
              <div style={{ fontSize: 14, color: 'var(--p2a-dark-fg-2)', marginTop: 6, marginBottom: 20 }}>
                {r.kind}
              </div>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 900px) {
          .clients-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 520px) {
          .clients-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
